var _defs, _rect, _path, _path2, _g, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f4f6f7;}.b{fill:#4095db;}.c{fill:#f4b662;}.d{fill:#0071ce;}.e{fill:rgba(229,229,229,0);}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 21,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2,0H30a2,2,0,0,1,2,2V5a0,0,0,0,1,0,0H0A0,0,0,0,1,0,5V2A2,2,0,0,1,2,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H32a0,0,0,0,1,0,0V3a2,2,0,0,1-2,2H2A2,2,0,0,1,0,3V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 16)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.115 7.229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M11.7,0A2.189,2.189,0,0,0,9.256,2.064a2.006,2.006,0,0,0,1.267,1.7c.565.306.754.5.752.776,0,.419-.451.61-.866.61a2.646,2.646,0,0,1-1.364-.328l-.186-.1-.2,1.4a3.993,3.993,0,0,0,1.613.333c1.52,0,2.509-.838,2.521-2.136a1.879,1.879,0,0,0-1.216-1.7c-.506-.29-.816-.483-.813-.776,0-.259.259-.537.829-.537h.049a2.309,2.309,0,0,1,1.034.24l.13.072L13,.263A3.231,3.231,0,0,0,11.7,0ZM8.654.109H7.206L6.3,6.362H7.748L8.654.11Zm-6.3,0H.019L0,.239A5.6,5.6,0,0,1,1.521.925L2.808,6.357H4.341L6.62.114H5.086L3.669,4.378l-.152-.867L3.01.638A.615.615,0,0,0,2.353.11Zm14.36.005h-1.12a.713.713,0,0,0-.759.518l-2.149,5.73h1.52c0-.008.251-.777.3-.94h.835l1.019,0c.044.215.175.929.176.936h1.344L16.714.116ZM15.5,2.4c0-.008.014-.047.071-.221.039-.119.087-.263.122-.375l.1.539c.012.062.28,1.5.335,1.805h-1.2c.118-.354.562-1.7.577-1.747h0Z",
    transform: "translate(0 0)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 32,
    height: 21,
    rx: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVisa);
export default __webpack_public_path__ + "static/media/icn-visa.ce2b6854095e98ed053bb0960fef7191.svg";
export { ForwardRef as ReactComponent };